export const DOCUMENT_SCAN_ENTRY_POINTS = [
  "CASE_CHAT",
  "FA_WIZARD",
  "POST_ESCALATION",
  "HOME",
  "OTHER",
] as const;

/** Where the user opened the native document scanner from. */
export type DocumentScanEntryPoint =
  (typeof DOCUMENT_SCAN_ENTRY_POINTS)[number];

/**
 * Collapse a batch of per-file entry points to a single provenance value, or
 * `undefined` if the batch isn't unanimous. Keeps the "a mixed batch degrades
 * to excluded rather than inheriting file[0]'s provenance" invariant in one
 * place — the client upload provider and the home-upload flow both derive from
 * it so they can't drift.
 */
export const deriveBatchScanbotEntryPoint = (
  entryPoints: (DocumentScanEntryPoint | undefined)[],
): DocumentScanEntryPoint | undefined => {
  const unique = new Set(entryPoints);
  return unique.size === 1 ? entryPoints[0] : undefined;
};
